import { createContext, useEffect, useState, } from 'react';
import { useQuery } from 'react-query';
import { getAllStateOption, getEnvInfo, getEnvironment } from '../api/resources';
import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { AUTH_TOKEN } from '../config/constants';
import socketMaintenance from '../utils/socketMaintenance';
import { getAllStateAgent } from '../api/agentResources';
import { renderCssRoot } from '../utils/renderCss';
import { useDispatch } from 'react-redux';
import { loadEnvInfoSuccess } from '../Redux/Actions/envInfo';


export const AppContext = createContext({
  isAuthenticated: false,
  funcLogin: () => { },
  funcLogout: () => { },
  title: '',
  cssInner: '',
  listEnvInfo: [],
  environment: {},
  listState: [],
  listStateAgent: []
});

export const AppContextProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [title, setTitle] = useState('');
  const [cssInner, setCssInner] = useState('');
  const [environment, setEnvironment] = useState({});
  const [listState, setListState] = useState([]);
  const [listStateAgent, setListStateAgent] = useState([]);
  const [listEnvInfo, setListEnvInfo] = useState([]);
  const dispatch = useDispatch();

  const { data: envInfoRaw } = useQuery('getEnvInfo', getEnvInfo, { cacheTime: Infinity });
  const { data: environmentRaw } = useQuery('environment', getEnvironment, { cacheTime: Infinity, });
  const { data: listStateRaw } = useQuery('listState', getAllStateOption, { cacheTime: Infinity });
  const { data: listStateAgentRaw } = useQuery('listStateAgent', getAllStateAgent, { cacheTime: Infinity });
  // const listEnvInfo = useSelector((state) => state?.envInfo?.data || []);

  useEffect(() => {
    /// dispatch
    if (envInfoRaw?.data) {
      const dataEnvInfo = envInfoRaw?.data || [];
      setListEnvInfo(dataEnvInfo);
      dispatch(loadEnvInfoSuccess({ data: dataEnvInfo, totalRow: envInfoRaw?.data?.totalRow }));
    }
  }, [envInfoRaw]);

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      /// disable react-dev-tools for this project
      if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
        for (let [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
          window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value == 'function' ? () => {} : null;
        }
      }
    }
  }, []);

  useEffect(() => {
    if (environmentRaw?.data) {
      setEnvironment(environmentRaw.data);
    }
  }, [environmentRaw]);

  useEffect(() => {
    if (listStateRaw?.data) {
      setListState(listStateRaw.data);
    }
  }, [listStateRaw]);

  useEffect(() => {
    if (listStateAgentRaw?.data) {
      setListStateAgent(listStateAgentRaw.data);
    }
  }, [listStateAgentRaw]);

  useEffect(() => {
    setIsAuthenticated(!!Cookies.get(AUTH_TOKEN));
  }, []);

  useEffect(() => {
    socketMaintenance();
  }, []);

  useEffect(() => {
    if (listEnvInfo) {
      /// TODO conflict title seo defined
      setTitle(listEnvInfo?.find(val => val.code === 'web/title')?.content ? listEnvInfo?.find(val => val.code === 'web/title')?.content : '');
      document.title =''
    }
  }, [listEnvInfo]);

  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (listEnvInfo) {
      /// css variable
      const cssInnerHTML = renderCssRoot(listEnvInfo);

      // const headElement = document.getElementsByTagName('head')[0];
      // const styleElement = document.createElement('style');
      // styleElement.type = 'text/css';
      // styleElement.innerHTML = cssInnerHTML;
      // headElement.appendChild(styleElement);
      setCssInner(cssInnerHTML);
    }
  }, [listEnvInfo]);

  function funcLogin(val) {
    setIsAuthenticated(val);
  };

  function funcLogout() {
    setIsAuthenticated(false);
  };

  return (
    <AppContext.Provider value={{
      isAuthenticated,
      funcLogin,
      funcLogout,
      title,
      cssInner,
      listEnvInfo,
      environment,
      listState,
      listStateAgent,
    }}>
      {children}
    </AppContext.Provider>
  );
};
